module.exports = __webpack_public_path__ + "img/arte_leave.90786a14.jpg";